import React from "react";
import styled from "@emotion/styled";

const Container = styled.div(() => ({
  width: "67px",
  height: "30px",
  borderRadius: "20px",
  display: "flex",
  alignItems: "center",
  paddingLeft: "4px",
  paddingRight: "4px",
}));

const ContainerUnlocked = styled(Container)(() => ({
  backgroundColor: "#F6F7FA",
  justifyContent: "flex-end",
}));

const ContainerLocked = styled(Container)(() => ({
  backgroundColor: "#F2F2F5",
  justifyContent: "flex-start",
}));

const IconBlockLocked = styled(Container)(() => ({
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#8AC18A",
  cursor: "pointer",
}));

const IconBlockUnlocked = styled(Container)(() => ({
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#507170",
  cursor: "pointer",
}));

export const SwitchLock = (props: any) => {
  const { locked, onClick } = props;
  return (
    <>
      {locked ? (
        <ContainerLocked>
          <IconBlockLocked onClick={onClick}></IconBlockLocked>
        </ContainerLocked>
      ) : (
        <ContainerUnlocked>
          <IconBlockUnlocked onClick={onClick}></IconBlockUnlocked>
        </ContainerUnlocked>
      )}
    </>
  );
};
